import * as React from 'react';

import user from 'js/lib/user';

import CourseraPlusNotificationsContainer from 'bundles/coursera-plus-common/components/lihp/CourseraPlusNotificationsContainer';
import { usePageContext } from 'bundles/page-config-common/contexts/PageContext';
import { useEnterpriseInProgressCourse } from 'bundles/page-config-common/contexts/enterprise/EnterpriseEnrolledCourseContext';
import CanceledSubscriptionReactivateNotification from 'bundles/subscriptions-common/components/CanceledSubscriptionReactivateNotification';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import ConsumerNotificationsNotConfigurable from 'bundles/unified-home-common/components/consumer/ConsumerNotificationsNotConfigurable';
import EnterpriseS12nVersioningNotification from 'bundles/unified-home-common/components/enterprise/EnterpriseS12nVersioningNotification';
import PrivacyBannerNotConfigurable from 'bundles/unified-home-common/components/shared/PrivacyBannerNotConfigurable';

const NotificationModuleRenderer = () => {
  const pageContext = usePageContext();
  const { inProgressCourse } = useEnterpriseInProgressCourse();
  const program = useProgram();
  const programId = program?.id;
  const userId = user.get().id;

  if (pageContext?.isEnterprise) {
    if (!inProgressCourse || !inProgressCourse.isS12n || !inProgressCourse.canUpgrade || !programId) {
      return <PrivacyBannerNotConfigurable />;
    }

    return (
      <>
        <PrivacyBannerNotConfigurable />
        <EnterpriseS12nVersioningNotification userId={userId} product={inProgressCourse} programId={programId} />
      </>
    );
  } else if (pageContext?.isConsumer) {
    return (
      <>
        <CanceledSubscriptionReactivateNotification />
        <CourseraPlusNotificationsContainer />
        <PrivacyBannerNotConfigurable />
        <ConsumerNotificationsNotConfigurable />
      </>
    );
  } else {
    return null;
  }
};

export default NotificationModuleRenderer;
